import React from 'react';
import { Drawer } from '../../components';
import FormCreatePrivateVehicles from '../../components/molecules/configuration/privateVehicles/createVehicles';
import { useStyles } from '../../services/material-ui';

const CreatePrivateVehicleForm: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormCreatePrivateVehicles />
      </main>
    </div>
  );
};

export default CreatePrivateVehicleForm;
